<template>
  <div>
    <el-row style="margin-top: 20px; padding-left: 5px">
      <el-col :sm="12">
        <div style="display: inline-block; margin-right: 10px">
          <strong style="font-size: 13px">{{ $t('select.shop') }}</strong><br>
          <el-select size="small" :placeholder="$t('select.shop')" v-model="shopee_shop.selected"
                     :disabled="loading.get_metrics" filterable>
            <el-option-group :label="$t('shop.added')">
              <el-option v-for="item in shopee_shop.list.filter(i => !i.is_sub_account)" :key="item.username"
                         :label="`${item.username} ${item.name}`" :value="item._id">
                <div>
                  <table style="width:100%;">
                    <tbody>
                    <tr>
                      <td style="width:40px;">
                        <img style="width:28px; height:28px; border-radius: 50vh;"
                             :src="logo_channel(item.channel)"
                             alt="image">
                      </td>
                      <td style="padding-left:10px;">
                        {{ item.username }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </el-option>
            </el-option-group>
            <el-option-group :label="$t('shop.managed')">
              <el-option v-for="item in shopee_shop.list.filter(i => i.is_sub_account)" :key="item.username"
                         :label="`${item.username} ${item.name}`" :value="item._id">
                <div>
                  <table style="width:100%;">
                    <tbody>
                    <tr>
                      <td style="width:40px;">
                        <img style="width:28px; height:28px; border-radius: 50vh;"
                             :src="logo_channel(item.channel)"
                             alt="image">
                      </td>
                      <td style="padding-left:10px;">
                        {{ item.username }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div style="display: inline-block; margin-left: 20px">
          <strong style="font-size: 13px">Chọn file kế hoạch</strong><br>
          <el-select v-model="selected_file_id" value="" size="mini" filterable @change="m__load_file_data">
            <el-option v-for="item in agency_files" :key="item.id" :value="item.id" :label="item.filename"></el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>

    <el-row style="margin-top: 60px; padding-left: 5px">
      <el-row>
        <el-col :sm="12">
          <strong class="text-primary" style="font-size: 13px">Kết quả thực hiện kế hoạch
            <template v-if="selected_file_id && selected_file">: {{ selected_file.filename }}</template>
          </strong>
        </el-col>
      </el-row>

      <el-table :data="plan_order_product_list" style="margin-top: 10px">
        <!--            <el-table-column width="40px">-->
        <!--              <template slot-scope="scope">-->
        <!--                <el-checkbox size="mini" v-model="scope.row.selected"></el-checkbox>-->
        <!--              </template>-->
        <!--            </el-table-column>-->
        <el-table-column :label="$t('base.product')" show-tooltip-when-overflow width="300px">
          <template slot-scope="scope">
            <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="logo"
                 style="width:35px; height: 35px;"> &nbsp;&nbsp;&nbsp; {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="Kế hoạch tháng" align="center">
          <el-table-column label="Tổng GMV" width="200px" prop="plan_gmv">
            <template slot-scope="scope">
              <strong style="font-size: 12px" class="text-danger">Kế hoạch: {{ scope.row.plan_gmv |currency }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-primary">Thực hiện: {{
                  scope.row.current_gmv |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-success">% hoàn thành: {{
                  scope.row.percent_gmv
                }}%</strong>
            </template>
          </el-table-column>
          <el-table-column label="Tổng Traffic" width="200px" prop="plan_traffic">
            <template slot-scope="scope">
              <strong style="font-size: 12px" class="text-danger">Kế hoạch: {{
                  scope.row.plan_traffic |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-primary">Thực hiện: {{
                  scope.row.current_traffic |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-success">% hoàn thành: {{
                  scope.row.percent_traffic
                }}%</strong>
            </template>
          </el-table-column>
          <el-table-column label="Tổng Đơn hàng" width="200px" prop="plan_order">
            <template slot-scope="scope">
              <strong style="font-size: 12px" class="text-danger">Kế hoạch: {{
                  scope.row.plan_order |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-primary">Thực hiện: {{
                  scope.row.current_order |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-success">% hoàn thành: {{
                  scope.row.percent_order
                }}%</strong>
            </template>
          </el-table-column>
          <el-table-column label="Tổng Đơn hàng max" width="200px" prop="plan_order_max">
            <template slot-scope="scope">
              <strong style="font-size: 12px" class="text-danger">Kế hoạch: {{
                  scope.row.plan_order_max |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-primary">Thực hiện: {{
                  scope.row.current_order_max |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-success">% hoàn thành: {{
                  scope.row.percent_order_max
                }}%</strong>
            </template>
          </el-table-column>
          <el-table-column label="Tổng GMV Ads" width="200px" prop="plan_gmv_ads">
            <template slot-scope="scope">
              <strong style="font-size: 12px" class="text-danger">Kế hoạch: {{
                  scope.row.plan_gmv_ads |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-primary">Thực hiện: {{
                  scope.row.current_gmv_ads |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-success">% hoàn thành: {{
                  scope.row.percent_gmv_ads
                }}%</strong>
            </template>
          </el-table-column>
          <el-table-column label="Tổng Click Ads" width="200px" prop="plan_click_ads">
            <template slot-scope="scope">
              <strong style="font-size: 12px" class="text-danger">Kế hoạch: {{
                  scope.row.plan_click_ads |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-primary">Thực hiện: {{
                  scope.row.current_click_ads |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-success">% hoàn thành: {{
                  scope.row.percent_click_ads
                }}%</strong>
            </template>
          </el-table-column>
          <el-table-column label="Tổng Đơn hàng Ads" width="200px" prop="plan_order_ads">
            <template slot-scope="scope">
              <strong style="font-size: 12px" class="text-danger">Kế hoạch: {{
                  scope.row.plan_order_ads |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-primary">Thực hiện: {{
                  scope.row.current_order_ads |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-success">% hoàn thành: {{
                  scope.row.percent_order_ads
                }}%</strong>
            </template>
          </el-table-column>
          <el-table-column label="Tổng Đơn hàng Ads max" width="200px" prop="plan_order_ads_max">
            <template slot-scope="scope">
              <strong style="font-size: 12px" class="text-danger">Kế hoạch: {{
                  scope.row.plan_order_ads_max |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-primary">Thực hiện: {{
                  scope.row.current_order_ads_max |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-success">% hoàn thành:
                {{ scope.row.percent_order_ads_max }}%</strong>
            </template>
          </el-table-column>
          <el-table-column :label="$t('metric.ads_expense')" width="200px" prop="plan_cost_ads">
            <template slot-scope="scope">
              <strong style="font-size: 12px" class="text-danger">Kế hoạch: {{
                  scope.row.plan_cost_ads |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-primary">Thực hiện: {{
                  scope.row.current_cost_ads |currency
                }}</strong>
              <br>
              <strong style="font-size: 12px" class="text-success">% hoàn thành: {{
                  scope.row.percent_cost_ads
                }}%</strong>
            </template>
          </el-table-column>
        </el-table-column>
        <!--        <el-table-column label="Kế hoạch ngày sale" align="center">-->
        <!--          <el-table-column label="GMV Ngày sale" width="120px" prop="plan_gmv_sale">-->
        <!--            <template slot-scope="scope">-->
        <!--              <el-input type="number" size="mini" v-model="scope.row.plan_gmv_sale">-->
        <!--              </el-input>-->
        <!--              <br>-->
        <!--              <strong style="font-size: 12px" class="text-danger">{{ scope.row.plan_gmv_sale | currency }}</strong>-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--          <el-table-column label="GMV Ads Ngày sale" width="120px" prop="plan_gmv_ads_sale">-->
        <!--            <template slot-scope="scope">-->
        <!--              <el-input type="number" size="mini" v-model="scope.row.plan_gmv_ads_sale">-->
        <!--              </el-input>-->
        <!--              <br>-->
        <!--              <strong style="font-size: 12px"-->
        <!--                      class="text-danger">{{ scope.row.plan_gmv_ads_sale | currency }}</strong>-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--          <el-table-column label="Traffic Ngày sale" width="120px" prop="plan_traffic_sale">-->
        <!--            <template slot-scope="scope">-->
        <!--              <el-input type="number" size="mini" v-model="scope.row.plan_traffic_sale">-->
        <!--              </el-input>-->
        <!--              <br>-->
        <!--              <strong style="font-size: 12px"-->
        <!--                      class="text-danger">{{ scope.row.plan_traffic_sale | currency }}</strong>-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--          <el-table-column label="Click Ads Ngày sale" width="120px" prop="plan_click_ads_sale">-->
        <!--            <template slot-scope="scope">-->
        <!--              <el-input type="number" size="mini" v-model="scope.row.plan_click_ads_sale">-->
        <!--              </el-input>-->
        <!--              <br>-->
        <!--              <strong style="font-size: 12px"-->
        <!--                      class="text-danger">{{ scope.row.plan_click_ads_sale | currency }}</strong>-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--          <el-table-column label="Chi phí Ads Ngày sale" width="120px" prop="plan_cost_ads_sale">-->
        <!--            <template slot-scope="scope">-->
        <!--              <el-input type="number" size="mini" v-model="scope.row.plan_cost_ads_sale">-->
        <!--              </el-input>-->
        <!--              <br>-->
        <!--              <strong style="font-size: 12px"-->
        <!--                      class="text-danger">{{ scope.row.plan_cost_ads_sale | currency }}</strong>-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--        </el-table-column>-->
        <!--        <el-table-column label="Kế hoạch ngày thường" align="center">-->
        <!--          <el-table-column label="GMV Ngày thường" width="120px" prop="plan_gmv_day">-->
        <!--            <template slot-scope="scope">-->
        <!--              <el-input type="number" size="mini" v-model="scope.row.plan_gmv_day">-->
        <!--              </el-input>-->
        <!--              <br>-->
        <!--              <strong style="font-size: 12px" class="text-danger">{{ scope.row.plan_gmv_day | currency }}</strong>-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--          <el-table-column label="GMV Ads Ngày thường" width="120px" prop="plan_gmv_ads_day">-->
        <!--            <template slot-scope="scope">-->
        <!--              <el-input type="number" size="mini" v-model="scope.row.plan_gmv_ads_day">-->
        <!--              </el-input>-->
        <!--              <br>-->
        <!--              <strong style="font-size: 12px" class="text-danger">{{-->
        <!--                  scope.row.plan_gmv_ads_day | currency-->
        <!--                }}</strong>-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--          <el-table-column label="Traffic Ngày thường" width="120px" prop="plan_traffic_day">-->
        <!--            <template slot-scope="scope">-->
        <!--              <el-input type="number" size="mini" v-model="scope.row.plan_traffic_day">-->
        <!--              </el-input>-->
        <!--              <br>-->
        <!--              <strong style="font-size: 12px" class="text-danger">{{-->
        <!--                  scope.row.plan_traffic_day | currency-->
        <!--                }}</strong>-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--          <el-table-column label="Click Ads Ngày thường" width="120px" prop="plan_click_ads_day">-->
        <!--            <template slot-scope="scope">-->
        <!--              <el-input type="number" size="mini" v-model="scope.row.plan_click_ads_day">-->
        <!--              </el-input>-->
        <!--              <br>-->
        <!--              <strong style="font-size: 12px"-->
        <!--                      class="text-danger">{{ scope.row.plan_click_ads_day | currency }}</strong>-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--          <el-table-column label="Chi phí Ads Ngày thường" width="120px" prop="plan_cost_ads_day">-->
        <!--            <template slot-scope="scope">-->
        <!--              <el-input type="number" size="mini" v-model="scope.row.plan_cost_ads_day">-->
        <!--              </el-input>-->
        <!--              <br>-->
        <!--              <strong style="font-size: 12px"-->
        <!--                      class="text-danger">{{ scope.row.plan_cost_ads_day | currency }}</strong>-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--        </el-table-column>-->
      </el-table>
    </el-row>
  </div>
</template>

<script>
import {orderBy as _orderBy} from 'lodash'
import {map_campaign_data} from '../../addon/ads_function'
import {get_shop_mixins} from '../../mixins/get_shop';

export default {
  mixins: [get_shop_mixins],

  data() {
    return {
      seller: null,
      send_request_list: [],
      agency_files: [],
      selected_file: {},
      selected_file_id: null,
      loading: {
        generate_data: false,
        save_file: false,
        calculate: false,
        get_metrics: false,
        get_product: false,
        select_product: false
      },
      plan_order_product_list: []

    }
  },

  async beforeMount() {
    await this.m__get_shopee_shop()

    // await this.sleep(2000)
    // await this.m__get_agency_file()
  },

  watch: {
    'shopee_shop.selected': function () {
      this.m__initial_view()
    }
  },

  methods: {
    async m__initial_view() {
      let items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)
      if (!this.check_role(items[0], 'marketing', 'flash_sale')) {
        return
      }

      try {
        if (this.shopee_shop.selected.length > 6) {
          if (items.length > 0) {
            this.selected_shop = items[0]
            let item = items[0]
            this.shop = item
            this.seller = await this.init_seller(item)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              return
            }

            await Promise.all([
              await this.m__get_agency_file()
            ])

            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)
          }
        }
      } catch (e) {
        console.log(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      } finally {
      }
    },

    async m__get_agency_file() {
      this.agency_files = []
      this.selected_file_id = null
      // const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/all', {
      // const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file', {
      const mipeeUserIds = [this.$store.state.userInfo.username, ...this.send_request_list.filter(i => i.status === 'accepted').map(i => i.request_user.username)].join(',')
      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/list/order', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          mipeeUserIds
        }
      })
      for (const item of resp.body) {
        item.loading = false
      }
      // this.agency_files = resp.body.filter(i => this.$store.state.userInfo.username === 'vuducminhdev07' ? true : this.shopee_shop.list.some(ii => ii._id === i.shopId))
      this.agency_files = resp.body.filter(i => this.$store.state.userInfo.username === 'vuducminhdev07' ? true : i.shopId === this.shopee_shop.selected)

      // console.log(this.agency_files)
      if (this.agency_files.length) {
        const first = _orderBy(this.agency_files, ['year', 'month', 'createdAt'], ['desc', 'desc', 'desc'])[0]
        this.ntf_s('Đã sử dụng file kế hoạch: ' + first.filename)
        this.selected_file_id = first.id
        await this.m__load_file_data()
      }
    },

    async m__load_file_data(file_id) {
      const found = this.agency_files.find(i => i.id === file_id || this.selected_file_id)
      if (!found) {
        return
      }

      console.log(found)
      // this.shopee_shop.selected

      this.selected_file = found
      // console.log(found)
      const date = this.dayjs([found.year, found.month])
      const start_time = date.clone().startOf('month').unix()
      const end_time = this.dayjs().month() === date.month()
        ? this.dayjs().startOf('d').unix()
        : date.clone().endOf('month').add(1, 'second').unix()
      const end_time_ads = this.dayjs().month() === date.month()
        ? this.dayjs().endOf('d').unix()
        : date.clone().endOf('month').unix()

      console.log('start_time', start_time)
      console.log('end_time', end_time)

      const data = JSON.parse(found.data)
      for (const item of data) {
        let gmv = 0, cr = 0, placed_buyers = 0, uv = 0, order = 0, gmv_ads = 0, click_ads = 0, cost_ads = 0,
          order_ads = 0

        const product_response = await this.seller.get_product_by_graphql([item.itemid.toString()])
        const product_name = product_response.data.products.items[0].name
        // console.log('compare', item.name === product_name)
        const get_product_performance_response = await this.seller.get_product_performance_v3(1, 20, start_time, end_time, 'month', product_name)
        console.log(get_product_performance_response)
        if (get_product_performance_response && get_product_performance_response.data && get_product_performance_response.data.result && get_product_performance_response.data.result.items) {
          // console.log(get_product_performance_response.data.result.items)
          const found = get_product_performance_response.data.result.items.find(i => i.id = item.itemid)
          console.log('found', found)
          if (found) {
            gmv += +found.placed_sales
            placed_buyers += +found.placed_buyers
            uv += +found.uv
            order += +found.placed_units
          }
        }
        cr = uv ? +(placed_buyers / uv * 100).toFixed(2) : 0

        const limit = 50, offset = 0, state = 'all',
          filter = {
            campaign_type: 'product_homepage',
            search_term: item.itemid.toString(),
            state: state
          }
        let campaign_response = await this.seller.marketing_pas_get_campaigns(start_time, end_time_ads, offset, limit, filter)
        campaign_response = map_campaign_data(campaign_response, true)
        console.log('campaign_response', campaign_response)

        if (campaign_response && campaign_response.data && campaign_response.data.campaign_ads_list) {
          const [gmv_ads_value, click_ads_value, cost_ads_value, order_ads_value] = campaign_response.data.campaign_ads_list.reduce((t, i) => {
            t[0] += Number(i.report.broad_gmv.value)
            t[1] += Number(i.report.click.value)
            t[2] += Number(i.report.cost.value)
            t[3] += Number(i.report.broad_order.value)
            return t
          }, [0, 0, 0, 0])

          gmv_ads += gmv_ads_value
          click_ads += click_ads_value
          cost_ads += cost_ads_value
          order_ads += order_ads_value
        }

        // const search_response = await this.seller.marketing_get_time_graph('search_product', start_time, end_time, {item_id: item.itemid})
        // if (search_response && search_response.data) {
        //   const search_metrics = map_graph_response(search_response.data.report_aggregate)
        //   if (search_metrics && +search_metrics.broad_gmv) {
        //     gmv_ads += +search_metrics.broad_gmv
        //     click_ads += +search_metrics.click
        //     cost_ads += +search_metrics.cost
        //     order_ads += +search_metrics.broad_order
        //   }
        // }
        //
        // const targeting_response = await this.seller.marketing_get_time_graph('targeting', start_time, end_time, {item_id: item.itemid})
        // if (targeting_response && targeting_response.data) {
        //   const targeting_metrics = map_graph_response(targeting_response.data.report_aggregate)
        //   if (targeting_metrics && +targeting_metrics.broad_gmv) {
        //     gmv_ads += +targeting_metrics.broad_gmv
        //     click_ads += +targeting_metrics.click
        //     cost_ads += +targeting_metrics.cost
        //     order_ads += +targeting_metrics.broad_order
        //   }
        // }

        // console.log(gmv_ads)
        // console.log(click_ads)
        // console.log(order_ads)
        // console.log(cost_ads)

        item.current_gmv = gmv
        item.percent_gmv = this.is_percent_of(gmv, item.plan_gmv)
        item.current_traffic = uv
        item.percent_traffic = this.is_percent_of(uv, item.plan_traffic)
        item.current_order = order
        item.percent_order = this.is_percent_of(order, item.plan_order)
        item.current_order_max = order
        item.percent_order_max = this.is_percent_of(order, item.plan_order)

        item.current_gmv_ads = gmv_ads
        item.percent_gmv_ads = this.is_percent_of(gmv_ads, item.plan_gmv_ads)
        item.current_click_ads = click_ads
        item.percent_click_ads = this.is_percent_of(click_ads, item.plan_click_ads)
        item.current_order_ads = order_ads
        item.percent_order_ads = this.is_percent_of(order_ads, item.plan_order_ads)
        item.current_order_ads_max = order_ads
        item.percent_order_ads_max = this.is_percent_of(order_ads, item.plan_order_ads_max)
        item.current_cost_ads = cost_ads
        item.percent_cost_ads = this.is_percent_of(cost_ads, item.plan_cost_ads)
      }

      this.plan_order_product_list = data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/agency/result_order.vue